var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 827.5,
    height: 30.5,
    viewBox: "0 0 827.5 30.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-289 -106)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 132,
    transform: "translate(317.5 121.5)",
    fill: "none",
    stroke: "#dc2342",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 132,
    transform: "translate(476.25 121.5)",
    fill: "none",
    stroke: "#dc2342",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 132,
    transform: "translate(636 122)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#dc2342",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#dc2342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(159.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-2",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#dc2342",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-2",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#dc2342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-3",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#dc2342",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-3",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#dc2342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(477.75 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-4",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-4",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-158.25 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 132,
    transform: "translate(953.25 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-5",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-5",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(2.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_58-2",
    "data-name": "Line 58",
    x2: 132,
    transform: "translate(953.25 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-2",
    "data-name": "Group 26",
    transform: "translate(795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-6",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-6",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6ca58cc19f17ca0138ddce2762bfc65a.svg";
export { ForwardRef as ReactComponent };